export const relationOptionsOptions: { label: string; id: string }[] = [
  { id: '_ALL_ROLES', label: 'Všechny role' },

  // A
  {
    id: 'AUTHOR',
    label: 'autor',
  },
  {
    id: 'CHOREOGRAPHER',
    label: 'autor choreografie/choreograf',
  },
  {
    id: 'AUTHOR_DIALOGS',
    label: 'autor dialogu',
  },
  {
    id: 'AUTHOR_ACCOMP_TEXT',
    label: 'autor doprovodného textu',
  },
  {
    id: 'COMPOSER',
    label: 'autor hudby/skladatel',
  },
  {
    id: 'AUTHOR_COMMENT',
    label: 'autor komentáře',
  },
  {
    id: 'AUTHOR_TOPIC',
    label: 'autor námětu',
  },
  {
    id: 'LYRICIST',
    label: 'autor textové složky/textař',
  },
  {
    id: 'AUTHOR_TEXT',
    label: 'autor textu',
  },
  {
    id: 'TRICKS_EFFECTS',
    label: 'autor triků a speciálních efektů',
  },
  {
    id: 'ARTWORK',
    label: 'autorské dílo',
  },

  // D
  {
    id: 'DISTRIBUTOR',
    label: 'distributor',
  },
  {
    id: 'DRAMATURG',
    label: 'dramaturg',
  },
  {
    id: 'HOLDER_SECURITY',
    label: 'držitel cenného papíru',
  },

  // E
  {
    id: 'EDITOR',
    label: 'editor',
  },

  // F
  {
    id: 'PHOTOGRAPHER',
    label: 'fotograf',
  },
  {
    id: 'POSITION',
    label: 'funkce',
  },

  // I
  {
    id: 'MUSIC_INTERPRETER',
    label: 'interpret hudby',
  },

  // K
  {
    id: 'CAMERAMAN',
    label: 'kameraman',
  },
  {
    id: 'CARTOGRAPHER',
    label: 'kartograf',
  },
  {
    id: 'CORPORATION_ASSIGNED',
    label: 'korporace výkonu funkce',
  },
  {
    id: 'DRAFTSMAN',
    label: 'kreslič',
  },

  // L
  {
    id: 'LECTOR',
    label: 'lektor',
  },

  // M (maj-, mat-, místo...)
  {
    id: 'OWNER_AUTHORIZED',
    label: 'majitel typáře',
  },
  {
    id: 'PLACE_REGISTER',
    label: 'matriční místo',
  },
  {
    id: 'LOCATION_PHOTOGRAPHING',
    label: 'místo fotografování',
  },
  {
    id: 'LOCATION_SHOOTING',
    label: 'místo natáčení',
  },
  {
    id: 'PLACE_HANDING',
    label: 'místo předání',
  },
  {
    id: 'LOCATION_ASSIGNED',
    label: 'místo výkonu funkce',
  },
  {
    id: 'LOCATION_PUBLISHING',
    label: 'místo vydání',
  },
  {
    id: 'LOCATION_PUBLISHER',
    label: 'místo vydavatele',
  },
  {
    id: 'PLACE_MANUFACTURE',
    label: 'místo výroby jednotky popisu',
  },
  {
    id: 'PLACE_ORIGIN',
    label: 'místo vzniku jednotky popisu',
  },
  {
    id: 'PLACE_COPY_CREATION',
    label: 'místo vzniku předlohy popisované kopie',
  },

  // N
  {
    id: 'PROPONENT',
    label: 'navrhovatel',
  },
  {
    id: 'PERSON_AWARDED',
    label: 'nositel vyznamenání/ceny',
  },

  // O (obrazově/objednavatel/odborná/odesílatel/opisovač/osoba)
  {
    id: 'CLIENT',
    label: 'objednavatel/příjemce',
  },
  {
    id: 'CAPTURED_ENTITY',
    label: 'obrazově a/nebo zvukově zachycená entita',
  },
  {
    id: 'COOPERATION',
    label: 'odborná spolupráce',
  },
  {
    id: 'SENDER',
    label: 'odesílatel',
  },
  {
    id: 'COPYIST',
    label: 'opisovač',
  },
  {
    id: 'PERSON_APPOINTED',
    label: 'osoba jmenovaná / ustanovená do funkce',
  },

  // P
  {
    id: 'SEALER',
    label: 'pečetitel',
  },
  {
    id: 'SCRIBE',
    label: 'písař',
  },
  {
    id: 'RECIPIENT',
    label: 'příjemce',
  },
  {
    id: 'PERSON_HANDING',
    label: 'předávající',
  },
  {
    id: 'TRANSLATOR',
    label: 'překladatel',
  },
  {
    id: 'PRODUCER',
    label: 'produkční společnost/producent',
  },
  {
    id: 'ORIGINATOR',
    label: 'původce',
  },

  // R
  {
    id: 'REDACTOR',
    label: 'redaktor',
  },
  {
    id: 'DIRECTOR',
    label: 'režisér',
  },

  // S
  {
    id: 'CLASSIFICATION',
    label: 'sekundární klasifikace',
  },
  {
    id: 'SCRIPTWRITER',
    label: 'scénárista',
  },
  {
    id: 'CUTTER',
    label: 'střih/střihač',
  },
  {
    id: 'BUILDER',
    label: 'stavitel',
  },
  {
    id: 'WITNESS',
    label: 'svědek',
  },
  {
    id: 'ENTITY',
    label: 'související entita',
  },
  {
    id: 'APPROVER',
    label: 'schvalovatel technického výkresu',
  },

  // T
  {
    id: 'PRINTER',
    label: 'tiskárna/tiskař',
  },
  {
    id: 'CREATOR_TECHNICAL',
    label: 'tvůrce technického zpracování',
  },
  {
    id: 'CREATOR_ARTWORK',
    label: 'tvůrce výtvarné stránky',
  },
  {
    id: 'TYPE',
    label: 'typové označení a název výrobku a typové stavby',
  },

  // U
  {
    id: 'PERFORMER',
    label: 'účinkující',
  },

  // V
  {
    id: 'MANUFACTURER',
    label: 'výrobce',
  },
  {
    id: 'MANUFACTURER_CARRIER',
    label: 'výrobce nosiče záznamu',
  },
  {
    id: 'PUBLISHER_OWNER',
    label: 'vydavatel',
  },
  {
    id: 'PUBLISHER',
    label: 'vydavatel/nakladatel',
  },
  {
    id: 'OWNER',
    label: 'vlastník',
  },
  {
    id: 'AWARD',
    label: 'vyznamenání/cena',
  },

  // Z
  {
    id: 'PROCESSOR_CARRIER',
    label: 'zpracovatel nosiče záznamu',
  },
  {
    id: 'SOUND',
    label: 'zvuk/zvukař',
  },

  // Ž (last)
  {
    id: 'APPLICANT',
    label: 'žadatel',
  },
];
